const notificationsConfig = [
  {
    section: 'Search Alerts',
    notifications: [
      {
        title: 'New Listings',
        type: 'NEW_LISTINGS',
        description:
          'Get notified when new listings go live, with specific updates for brands and models you select',
      },
    ],
  },
  {
    section: 'Bidding Activity',
    notifications: [
      {
        title: 'New Bids',
        type: 'NEW_BIDS',
        description: 'Alerts for every new bid on your items',
      },
      {
        title: 'Outbid Alerts',
        type: 'OUTBID_ALERTS',
        description: 'When someone bids higher than you',
      },
      {
        title: 'Auction Results',
        type: 'AUCTION_RESULTS',
        description: 'Status updates when you win or lose',
      },
      {
        title: 'Pending Bids',
        type: 'PENDING_BIDS',
        description: 'Alerts for bids requiring approval',
      },
    ],
  },
  {
    section: 'Auction Status',
    notifications: [
      {
        title: 'Lifecycle Updates',
        type: 'LIFECYCLE_UPDATES',
        description: 'When auctions start, end, or sell',
      },
      {
        title: 'Cancellations',
        type: 'CANCELLATIONS',
        description: 'Notifications for withdrawn listings',
      },
    ],
  },
  {
    section: 'Account & Verification',
    notifications: [
      {
        title: 'Verification Status',
        type: 'VERIFICATION_STATUS',
        description: 'Updates on your identity/location checks',
      },
      {
        title: 'Security Alerts',
        type: 'SECURITY_ALERTS',
        description: 'Critical notices about your account access',
      },
    ],
  },
  {
    section: 'Billing',
    notifications: [
      {
        title: 'Invoices & Credits',
        type: 'INVOICES_AND_CREDITS',
        description: 'New financial documents and adjustments',
      },
    ],
  },
  {
    section: 'Bid Moderation',
    notifications: [
      {
        title: 'Rejected Bids',
        type: 'REJECTED_BIDS',
        description: 'Notifications if a bid is declined',
      },
    ],
  },
];

export default notificationsConfig;
